<template>
  <hero-slider :sliders="sliders" :hero-banner="heroBanner" :categories="categories" />
</template>

<script setup>
import HeroSlider from './HeroSlider.vue'

defineProps({
  sliders: {
    type: Array,
    default: () => []
  },
  heroBanner: {
    type: Object,
    default: null
  },
  categories: {
    type: Array,
    default: () => []
  }
})
</script>
